import { render, staticRenderFns } from "./WidgetTickets.vue?vue&type=template&id=3618c29d&"
import script from "./WidgetTickets.vue?vue&type=script&lang=js&"
export * from "./WidgetTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports